import { Type, Expose } from "class-transformer";
import i18n from "@/i18n";


export class CropsDTO {
  public cropUuid!: string;
  public area!: number;
  public cropLabel!: number;

  @Type(() => Date)
  public seedingDate!: Date;

  @Type(() => Date)
  public estimatedHarvestDate!: Date;

  @Type(() => Date)
  public harvestDate!: Date;
  public cropType!: string;
  public yield!: number;
  public yieldScore!: string;
  public yieldScoreMicroRegion!: string;
  public yieldScoreState!: string;
  public yieldScoreCountry!: string;
  public harvestSeason!: string;
  public plotDoctorStatus: string = '';

  public enablePlanet!: boolean | null;

  @Type(() => CropStagesDTO)
  public cropStages!: CropStagesDTO[];
}

export class CropStagesDTO {
  @Type(() => Date)
  public date!: Date | null;

  public stage!: string;

  
  public get averageDate() {
    return this.date;
  }
}

export class CropsToCSV {

  public static withCropDTO(crop: CropsDTO) {
    return new CropsToCSV(crop);
  }
  
  public cropLabel!: number;
  public area!: string;
  public yield!: string;
  public production!: string;
  public yieldScore!: string;
  public yieldScoreMicroRegion!: string;
  public yieldScoreState!: string;
  public yieldScoreCountry!: string;
  public cropType!: string;
  public seedingDate!: string;
  public harvestDate!: string;

  constructor(crop: CropsDTO) {
    this.cropLabel = crop.cropLabel;
    this.area = Number(crop.area).toFixed(2).replace('.', ',');
    this.yield = Number(crop.yield).toFixed(2).replace('.', ',');
    this.production = Number(crop.yield * crop.area).toFixed(0);
    this.yieldScore = this.formattedYieldScore(crop.yieldScore);
    this.yieldScoreMicroRegion = this.formattedYieldScore(crop.yieldScoreMicroRegion);
    this.yieldScoreState = this.formattedYieldScore(crop.yieldScoreState);
    this.yieldScoreCountry = this.formattedYieldScore(crop.yieldScoreCountry);
    this.cropType = i18n.t(`crop-types.${crop.cropType}`).toString();
    this.seedingDate = this.formattedDate(crop.seedingDate);
    this.harvestDate = this.formattedDate(crop.harvestDate ? crop.harvestDate : crop.estimatedHarvestDate);
  }

  private formattedYieldScore(value: string) {
    if (!value) {
      return '';
    }
    return value.split("SCORE_")[1];
  }

  private formattedDate(value: Date) {
    if (!value) {
      return '';
    } else {
      const dateAux = new Date(value);
      dateAux.setUTCMinutes(dateAux.getUTCMinutes()+dateAux.getTimezoneOffset());
      return i18n.d(dateAux, 'short');
    }
  }
}

/**
 * Item de edição manual de HarvestData (contrato do endpoint
 * PATCH /senana/farm/analysis/{analysisUuid}/harvest-data/override).
 * As chaves seguem o snake_case exigido pelo backend.
 */
export interface HarvestDataOverrideDTO {
  // Chave (obrigatórios: identificam o registro do talhão)
  crop_uuid: string;
  harvest_season: string;
  crop_type: string;

  // Campos editáveis (opcionais: enviar só o que mudou)
  new_crop_type?: string;
  crop_type_confirmed?: boolean;
  seeding_date?: string;
  harvest_date?: string;
  yield?: number;
}

export interface HarvestDataOverrideResponse {
  analysis_uuid: string;
  recalc_status: string;
  updated: Array<{
    crop_uuid: string;
    crop_label: number;
    harvest_season: string;
    crop_type: string;
    crop_type_confirmed: boolean;
    crop_type_probability: number;
    seeding_date: string;
    harvest_date: string;
    yield: number;
  }>;
}

export class CropsYieldEvolutionDTO {

  @Expose({ name: "yield" })
  public value!: number;

  @Type(() => Date)
  @Expose({ name: "scene_date" })
  public sceneDate!: Date;

}
